import React, { Fragment, Component } from "react";
import Divider from "./Divider";
import DOMPurify from "dompurify";

let greyStyle = {
  backgroundColor: "#f7f7f7",
  border: "1px solid #e2e2e2",
  padding: "1rem",
  fontStyle: "normal",
  lineHeight: "1.6",
};
let link = {
  color: "#337ab7",
  fontStyle: "normal",
  cursor: "pointer",
};

export default class PageInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMore: false,
      textMore: "Read More",
    };
  }
  onReadClick = () => {
    if (this.state.showMore === true) {
      this.setState({
        showMore: false,
        textMore: "Read More",
      });
    } else {
      this.setState({
        showMore: true,
        textMore: "Read Less",
      });
    }
  };
  render() {
    return (
      <Fragment>
        <div
          id={"page_level_info"}
          style={
            this.props.coloring === "grey"
              ? { ...greyStyle, ...this.props.css }
              : { ...this.props.css }
          }
        >
          {this.props.title && <h4>{this.props.title}</h4>}
          {!this.state.showMore && this.props.read_more ? (
            <span
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                  this.props.text.substr(0, this.props.character_limit, {
                    ADD_ATTR: ["target"],
                  })
                ),
              }}
            ></span>
          ) : (
            <span
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(this.props.text, {
                  ADD_ATTR: ["target"],
                }),
              }}
            ></span>
          )}
          {this.props.read_more ? (
            <div onClick={this.onReadClick} style={link}>
              <u>{this.state.textMore}</u>
            </div>
          ) : (
            ""
          )}
        </div>
        {this.props.divider !== false ? <Divider /> : null}
      </Fragment>
    );
  }
}
